import React, { useEffect, useMemo, useState } from 'react';

import { get } from '../Services/http';
import { translate } from '../Services/translation';
import constants from '../constants';
import InputField from './InputField';

export default function LanguageAndCountrySelector({
    countryItemsOverride = null,
    titleKey = 'country.choose',
    tipsKey = 'country.tips',
}) {
    const [data, setData] = useState({
        languageCode: constants.languages[0].value,
        countryCode: constants.countries[0].value,
    });
    const [searchTerm, setSearchTerm] = useState('');

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let languageCode = data.languageCode;
        let countryCode = data.countryCode;
        for (let i = 0; i < constants.languages.length; i++) {
            if (constants.languages[i].selected) {
                languageCode = constants.languages[i].value;
                break;
            }
        }
        for (let i = 0; i < constants.countries.length; i++) {
            if (constants.countries[i].selected) {
                countryCode = constants.countries[i].value;
                break;
            }
        }

        setData({
            languageCode: languageCode,
            countryCode: countryCode,
        });
    }, []);

    const onChange = (key, value) => {
        if (key === 'searchforlanguage') {
            setSearchTerm(value);
        }
    };

    const availableCountryItems =
        Array.isArray(countryItemsOverride) && countryItemsOverride.length
            ? countryItemsOverride
            : constants.countryItems;

    const filteredCountries = useMemo(() => {
        if (!searchTerm.trim()) {
            return availableCountryItems;
        }

        const search = searchTerm.toLowerCase();

        return availableCountryItems.filter((country) => {
            if (country.name.toLowerCase().includes(search)) {
                return true;
            }

            if (
                country.currencyCode &&
                country.currencyCode.toLowerCase().includes(search)
            ) {
                return true;
            }

            return country.countryUrls.some((url) =>
                url.language.toLowerCase().includes(search)
            );
        });
    }, [availableCountryItems, searchTerm]);

    const selectCountryAndLanguage = async (
        event,
        languageCode,
        countryCode,
        fallbackUrl
    ) => {
        event.preventDefault();
        setLoading(true);
        const requestContext = window.__litium.requestContext;
        const params = new URLSearchParams({
            languageCode,
            countryCode,
        });
        for (const key in requestContext) {
            if (Object.hasOwnProperty.call(requestContext, key)) {
                const element = requestContext[key];
                params.append(key, element);
            }
        }

        return get('/api/navigation/setcountry/?' + params.toString())
            .then((response) => response.text())
            .then((result) => {
                if (result.length) {
                    window.location.href = result;
                    return;
                }

                if (fallbackUrl) {
                    window.location.href = fallbackUrl;
                }
            })
            .catch((ex) => console.log(ex))
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <form>
            <div className="row">
                <div className="small-12">
                    <div className="modal-title">{translate(titleKey)}</div>
                </div>
            </div>
            <div className="row">
                <div className="small-12">
                    <InputField
                        label=""
                        id="searchforlanguage"
                        type="text"
                        name="searchforlanguage"
                        placeholder={translate('country.search')}
                        onChange={(value) =>
                            onChange('searchforlanguage', value)
                        }
                        errors={{}}
                    />
                </div>
                <div className="small-12"></div>

                <div className="small-12">
                    <p class="langs-info">
                        {translate(tipsKey)}
                    </p>
                    <div className="langs">
                        {filteredCountries.map((country, index) => {
                            const selected = country.countryUrls.find(
                                (url) => url.selected
                            );
                            return (
                                <div
                                    className={`lang${
                                        selected ? ' lang--selected' : ''
                                    }`}
                                    key={index}
                                >
                                    <div className="lang__header">
                                        <span
                                            className={`lang__code flag:${country.countryCode}`}
                                            aria-hidden="true"
                                        ></span>
                                        <p className={`lang__name`}>
                                            {country.currencyCode
                                                ? `${country.name} (${country.currencyCode})`
                                                : country.name}
                                        </p>
                                        {selected && (
                                            <span className="lang__check">
                                                &#x2713;
                                            </span>
                                        )}
                                    </div>
                                    <div className="lang__links">
                                        {country.countryUrls.map(
                                            (url, index) => (
                                                <a
                                                    className={`lang__link${
                                                        selected && url.selected
                                                            ? ' lang__link--selected'
                                                            : ''
                                                    }`}
                                                    href={url.url}
                                                    lang={url.languageCode}
                                                    hrefLang={url.languageCode}
                                                    onClick={(event) =>
                                                        selectCountryAndLanguage(
                                                            event,
                                                            url.languageCode,
                                                            country.countryCode,
                                                            url.url
                                                        )
                                                    }
                                                    aria-current={selected && url.selected || undefined}
                                                    key={index}
                                                >
                                                    {url.language}
                                                </a>
                                            )
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </form>
    );
}
